import React, { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Modal } from '@vectord/components';

import {
  BULK_DELETE_SBAT_GROUP_MODAL_STAGES,
  deleteSbatGroupsModalStageSelector,
  setDeleteSbatGroupsModalStage,
} from 'features/classCreation';
import BulkDeleteSbatGroupModalStageRenderer from '../BulkDeleteSbatGroupModalStageRenderer';
import styles from './BulkDeleteSbatGroupsModal.module.scss';

export default function BulkDeleteSbatGroupsModal() {
  const dispatch = useDispatch();
  const modalStage = useSelector(deleteSbatGroupsModalStageSelector);
  const isOpen = modalStage !== BULK_DELETE_SBAT_GROUP_MODAL_STAGES.notOpen;

  const handleModalClose = useCallback(() => {
    dispatch(
      setDeleteSbatGroupsModalStage(BULK_DELETE_SBAT_GROUP_MODAL_STAGES.notOpen)
    );
  }, [dispatch]);

  return (
    <Modal
      isOpen={isOpen}
      withoutHeader
      onClose={handleModalClose}
      unMountOnClose
      className={styles.root}
      size="large"
    >
      <BulkDeleteSbatGroupModalStageRenderer />
    </Modal>
  );
}
